import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Landing from '../landing/Landing';
import ObjectDescription from '../object-description/ObjectDescription';
import DownloadedList from '../downloaded_list/DownloadedList';
import DownloadedDescription from '../downloaded_description/DownloadedDescription';
import GroupDescription from '../group_description/GroupDescription';
import DownloadedGroups from '../downloaded_groups/DownloadedGroups';
import Search from '../search/Search';
import GroupDownloadedDescription from '../group_downloaded_description/GroupDownloadedDescription';
import Collections from '../collections/Collections';
import { urls } from './urls';

const Main = () => (
  <Switch>
    <Route exact path="/" component={Landing} />
    <Route
      exact
      path={'/' + urls.descargas_recursos + '/'}
      component={DownloadedList}
    />
    <Route
      exact
      path={'/' + urls.descargas_recursos + '/:id'}
      component={DownloadedDescription}
    />
    <Route
      exact
      path={'/' + urls.recursos + '/:object_id'}
      component={ObjectDescription}
    />
    <Route
      exact
      path={'/' + urls.descargas_agrupaciones + '/'}
      component={DownloadedGroups}
    />
    <Route
      exact
      path={'/' + urls.descargas_agrupaciones + '/:id'}
      component={GroupDownloadedDescription}
    />
    <Route
      exact
      path={'/' + urls.agrupaciones + '/:group_id'}
      component={GroupDescription}
    />
    <Route exact path={'/' + urls.busqueda + '/'} component={Search} />
    <Route exact path={'/' + urls.colecciones} component={Collections} />
  </Switch>
);
export default Main;
